import { useMutation, gql } from '@apollo/client';

const TASK_LIST_SECTION_TAG_TASK_IMAGES = gql`
  mutation TaskListSectionTagTaskImages(
    $input: TaskListSectionTagTaskImagesInput!
  ) {
    taskListSectionTagTaskImages(input: $input) {
      taskListSection {
        id
      }
      errors {
        message
      }
    }
  }
`;

const useSectionImageTag = () => {
  const [tagSectionImagesMutation] = useMutation(
    TASK_LIST_SECTION_TAG_TASK_IMAGES,
  );

  return {
    tagSectionImagesMutation,
  };
};

export default useSectionImageTag;
